<template>
	<a-row class="reportTableBox">
		<a-col :span='24' class="titleBox">
			<a-col :span='4' class="left">报表结果</a-col>
			<a-col :span='20' class="right">
				<a-button type="primary" class="btn" @click="showExportLog()">查看导出日志</a-button>
				<a-button type="primary" class="btn" @click="exportExcel()" :disabled='dataList.length == 0 || loading'>生成导出文件</a-button>
			</a-col>
		</a-col>
		<a-col :span="24">
			<a-table :columns="columns" :dataSource="dataList" :pagination="false" :loading="loading" bordered :scroll="{ x: tableLength, y: 400 }"></a-table>
		</a-col>
		<export-log ref="exportLog"></export-log>
	</a-row>
</template>

<script>
	import exportLog from './exportLog';
	import postHeight from '@/controllers/postHeight';
	export default {
		extends: postHeight,
		components: {
			exportLog
		},
		data() {
			return {
				columns: [],
				dataList: [],
				tableLength: 0,
				loading: false,
				params: {}
			}
		},
		mounted() {
			this.$root.$bus.$on("ReportQuery", this.ReportQuery);
			this.$root.$bus.$on("resetTable", this.resetTable);
		},
		destroyed() {
			this.$root.$bus.$off("ReportQuery");
			this.$root.$bus.$off("resetTable");
		},
		methods: {
			resetTable() {
				this.columns = [];
				this.dataList = [];
				this.postHeight();
			},
			// 查询报表
			ReportQuery(params = {}) {
				this.params = params;
				this.loading = true;
				this.columns = [];
				this.$axios.ReportQuery(params).then(response => {
					this.loading = false;
					if(response && response.success) {
						this.dataList = response.content;
						for(var key in response.content[0]) {
							this.columns.push({
								title: key,
								dataIndex: key,
								width: 180,
								align: "center",
								scopedSlots: {
									customRender: key
								}
							})
						}
						if(this.columns.length > 0) {
							this.tableLength = this.columns.map(ele => ele.width).reduce((l, r) => l + r) + 140;
						}
						this.dataList.map((ele, index) => {
							ele.key = index.toString();
						})
						this.postHeight();
					} else {
                        this.postHeight();
                    }
				})
			},
			// 查看导出日志
			showExportLog() {
				this.$refs.exportLog.show();
			},
			// 生成导出文件
			exportExcel() {
				let params = {
					Conditions: this.params.Conditions,
					ReportKey: this.params.ReportKey
				}
				this.$axios.ReportExport(params).then(response => {
					if(response && response.success) {
						this.$message.success(`文件生成成功，请点击"查看导出日志"前往下载`)
					}
				})
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.reportTableBox {
		margin-top: 16px;
		border: 1px solid #bfcbd9;
		padding: 16px;
		border-radius: 5px;
		.titleBox {
			padding-bottom: 10px;
			border-bottom: 1px dashed #bfcbd9;
			margin-bottom: 15px;
			.left {
				// font-weight: bold;
			}
			.right {
				text-align: right;
				.btn {
					width: 120px;
					margin-left: 16px;
				}
			}
		}
	}
</style>